<template>
  <div class="main box-shadow-default">
    <p class="type">
      业务类型：
      <span>{{ name }}</span>
    </p>
    <div class="wrap">
      <div class="title top">
        <span>认证信息</span>
        <div class="btnWrap">
          <el-button size="small" type="primary" @click="sendMessage()">短信通知</el-button>
          <el-button size="small" type="primary" @click="refresh()">刷新</el-button>
        </div>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="order" label="序号" width="120"></el-table-column>
        <el-table-column prop="name" label="姓名"></el-table-column>
        <el-table-column prop="phone" label="手机号"></el-table-column>
        <el-table-column label="二维码" v-if="$hasPermission('IEBDC:SQRZ:EWM')">
          <template slot-scope="scope">
            <img :src="scope.row.ewmURL" />
          </template>
        </el-table-column>
        <el-table-column prop="sprz" label="认证状态">
          <template slot-scope="scope">
            <!-- <span :class="scope.row.sprz ? 'redPoint' : ''">{{ scope.row.sprz ? '已认证' : '未认证' }}</span> -->
            <span :class="scope.row.xwbl ? 'redPoint' : ''">{{ scope.row.xwbl ? '已认证' : '未认证' }}</span>
          </template>
        </el-table-column>
      </el-table>
      <span class="redPoint noPerson" v-if="tableData.length <= 0">暂无认证申请人可直接进入下一步</span>
    </div>
    <!-- <div class="wrap authWrap">
      <div class="title">授权认证操作指引</div>
      <div class="imgWrap">
      </div>
    </div> -->
    <rzewm ref="rzewm" @refresh="refresh"></rzewm>
    <div class="main-footer text-center">
      <el-button type="primary" @click="prev()">上一步</el-button>
      <el-button type="primary" v-if="tableData.length > 0" @click="save()">认证完成</el-button>
      <el-button type="primary" @click="next()">下一步</el-button>
    </div>
  </div>
</template>

<script>
import rzewm from '../component/rzewm';
import { mapMutations, mapState } from 'vuex';
import { localDataUser } from '@iebdc/utils/local-data';
import applicantCertifyService from '@/pages/iebdc/api/apply/applicant-certify';
import applicantFinishService from '@/pages/iebdc/api/apply/applicant-finish';
export default {
  name: 'authorizedCertify',
  data() {
    return {
      tableData: [],
      name: '',
      sfrzPng: require('@/pages/iebdc/assets/images/sfrz.png'),
    };
  },
  computed: {
    // 下一步跳转所需数据
    ...mapState('wysq-step', ['nextItem']),
    ...mapState('wysq-data', ['flowInfoIng']),
  },
  created() {
    this.targetToStep('身份认证');
    this.applicantCertifyService();
    this.name = this.$store.getters.firstFlow ? this.$store.getters.firstFlow.thirdTypeData.name : '';
  },
  methods: {
    ...mapMutations('wysq-data', ['setFlowInfoIng']),
    // 跳转到下一页面
    ...mapMutations('wysq-step', ['targetToStep']),
    // 跳转到下一页面,需先校验当前页面数据状态 TODO
    next() {
      //个人用户才自动生成申请表
      if (localDataUser.get().userCategory === 'NORMAL') {
        this.getSqsEwm();
      }
      this.$router.push({
        name: this.nextItem.name,
      });
    },
    prev() {
      this.targetToStep('填写申请表');
      this.$router.push({
        name: 'applicantTable',
        params: { ywh: this.flowInfoIng.wwywh },
      });
    },
    //个人用户上传申请书
    async getSqsEwm() {
      let res = await applicantFinishService.getSqsEwm({ ywh: this.flowInfoIng.wwywh });
      if (res && res.data) {
        // this.$router.push({
        //   name: this.nextItem.name,
        // });
      } else {
        this.$message.error('上传申请书失败');
      }
    },
    //刷新
    refresh() {
      this.applicantCertifyService();
    },
    //发送短信
    async sendMessage() {
      const { success, data, message } = await applicantCertifyService.sendMsgToQlrAndYwr({
        qlxxId: this.flowInfoIng.id,
      });
      if (success && data) {
        this.$message.success('发送成功！');
      } else {
        this.$message.error(message);
      }
    },
    // 根据主业务号获取申请人的询问笔录/视频认证状态
    async applicantCertifyService() {
      if (!this.flowInfoIng.wwywh) return;
      const { success, data, message } = await applicantCertifyService.getSqrRzztByWwywh({
        wwywh: this.flowInfoIng.wwywh,
      });
      if (success && data) {
        (data || []).forEach((item, i) => {
          item.order = i + 1;
        });
        this.tableData = data;
      } else {
        this.$message.error(message);
      }
    },
    //提交申请
    save() {
      //判断需认证申请人是否已全部认证
      let tag = true;
      this.tableData.forEach((item) => {
        if (!item.xwbl) {
          tag = false;
        }
      });
      if (tag) {
        if (localDataUser.get().userCategory === 'NORMAL') {
          this.getSqsEwm();
        }
        this.next();
      } else {
        this.$message.warning('认证状态全部通过后才能下一步！');
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import 'src/styles/common-variables';
@import 'src/styles/public';
.main {
  padding: 20px 40px;
  letter-spacing: 1px;
  background-color: $background-color-layout;
  p {
    margin: 0 0 10px;
    text-align: justify;
    text-justify: inter-ideograph;
    &.weight {
      font-weight: 700;
      color: rgba(85, 85, 85, 1);
    }
  }
  .wrap {
    // border: 1px solid #dddddd;
    margin-bottom: 20px;
    .title {
      font-size: 16px;
      color: #333333;
      line-height: 50px;
      padding-left: 10px;
      overflow: hidden;
      .btnWrap {
        width: 160px;
        float: right;
        text-align: right;
      }
    }
    .top {
      padding-left: 0;
      margin-bottom: 10px;
      border-bottom: 1px solid #e6ebf5;
      span {
        float: left;
        padding: 0 5px;
        height: 34px;
        line-height: 30px;
        margin-top: 20px;
        border-bottom: 2px solid #2c8bff;
      }
    }
    .noPerson {
      line-height: 50px;
      margin-left: 10px;
    }
  }
  .authWrap {
    border: 1px solid #e6ebf5;
    .title {
      background: #f2f6fc;
      height: 40px;
      line-height: 40px;
      font-size: 14px;
    }
    .imgWrap {
      width: 100%;
      height: 1100px;
      position: relative;
      img {
        width: 95%;
        height: 95%;
        position: absolute;
        margin: auto;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
      }
    }
  }
  .type {
    span {
      font-weight: 700;
    }
  }
  /deep/ .el-table {
    border: 1px solid #e6ebf5;
    border-bottom: none !important;
  }
  /deep/ .el-table th {
    height: 20px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    background: #f2f6fc;
  }
  /deep/ .el-table tr {
    th:first-of-type,
    td:first-of-type {
      text-align: center;
    }
  }
  .redPoint {
    color: #ff5b24;
  }
}
</style>
